var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelescope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476 277.7l97-56L445 0 348 56 476 277.7zM336.3 99.7c-1-1.8-2-3.6-2.8-5.4L36.7 284.9l19.2 33.3L0 350.5l49.9 86.4 55.9-32.3 16.3 28.2 115.7-62.1L180.3 512h51.8L304 335.6 375.9 512h51.8L346.4 312.5l86.1-46.2-.2-.3-96-166.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelescope);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telescope.d770d766a97a33c0526fb8aaad937826.svg";